var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.$isBotAgent && !_vm.lastLazyLoaded)?_c('div',{staticClass:"d-flex align-center justify-center",staticStyle:{"height":"200px"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"50","color":"primary"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }